import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWaterLevel } from 'features/waterLevel/hooks/useWaterLevel';
import { AlertEditingLayout } from 'components/layouts/AlertEditingLayout';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { WaterLevelAlertForm } from 'features/waterLevel/components/WaterLevelAlertForm';
import { useWeatherAlert } from 'features/weatherAlerts/hooks/useWeatherAlert';

export const WaterLevelEditAlert = (): JSX.Element => {
  const { gaugeId, alertId } = useParams<{
    gaugeId: string;
    alertId?: string;
  }>();
  const { t } = useTranslation();
  const location = useLocation<{ fromRoute?: string }>();
  const {
    waterLevel,
    isLoading: isLoadingWaterLevel,
    isError: isErrorLoadingWaterLevel,
  } = useWaterLevel({ id: parseInt(gaugeId, 10) });
  const {
    alert: waterLevelAlert,
    isLoading: isLoadingAlert,
    isError: isErrorLoadingAlert,
  } = useWeatherAlert({ alertId: alertId ? parseInt(alertId, 10) : undefined });
  const isLoading = isLoadingWaterLevel || isLoadingAlert;
  const isError = isErrorLoadingWaterLevel || isErrorLoadingAlert;

  const returnRoute =
    location.state?.fromRoute || `/gauge/${gaugeId}?tab=notifications`;

  const status = getPageStatus({
    isLoading,
    isError: isError || !waterLevel,
  });

  return (
    <PageLayout
      status={status}
      headerBarProps={{
        title: alertId
          ? t('waterLevel.alerts.editNotification')
          : t('waterLevel.alerts.addNotification'),
        action: returnRoute,
      }}
    >
      {waterLevel && (
        <AlertEditingLayout>
          <WaterLevelAlertForm
            waterLevel={waterLevel}
            alert={waterLevelAlert}
            fromRoute={returnRoute}
          />
        </AlertEditingLayout>
      )}
    </PageLayout>
  );
};
